class Product {
    constructor(id, title, vendor, productCode, variants) {
        this.id = id;
        this.title = title;
        this.vendor = vendor;
        this.productCode = productCode;
        this.variants = variants;
    }

    getFkuByColorName(colorName) {
        if (colorName == null) {
            // 到達すべきでない
            console.error('colorName が NULLまたは未定義です.');
            return null;
        }
        if (colorName === 'ONE_COLOR') {
            // カラーなしの場合
            const colorCode = 999;
            return `${this.productCode}${colorCode}`;
        }
        const targetVariants = this.filterVariantsByOption(colorName);
        if (targetVariants.length < 1) {
            // 到達すべきでない
            console.error('colorName に対応するカラーコードが存在しません.');
            return null;
        }
        return `${this.productCode}${targetVariants[0].colorCode}`;
    }

    filterVariantsByOption(option) {
        return this.variants.filter(variant => variant.hasOption(option));
    }
}

class ProductVariant {
    constructor(id, sku, colorCode, options) {
        this.id = id;
        this.sku = sku;
        this.colorCode = colorCode;
        this.options = options
    }

    hasOption(value) {
       return this.options.includes(value);
    }
}

class ContactButton extends HTMLElement {
    constructor() {
        super();
        this.product = this.generateProduct();
        this.addEventListener('click', (event) => {
           this.transitionToContactPage();
        });
    }

    generateProduct() {
        const infoTarget = document.getElementById('product-info');
        const productCode = infoTarget.getAttribute('data-product-code');
        const variants = Array.from(infoTarget.children).map(span => {
            return new ProductVariant(
                span.getAttribute('data-variant-id'),
                span.getAttribute('data-variant-sku'),
                span.getAttribute('data-variant-color-code'),
                JSON.parse(span.getAttribute('data-variant-options')),
            );
        });
        return new Product(
            infoTarget.getAttribute('data-product-id'),
            infoTarget.getAttribute('data-product-title'),
            infoTarget.getAttribute('data-product-vendor'),
            productCode,
            variants,
        );
    }

    transitionToContactPage() {
        const lang = document.querySelector('html').lang === 'ja' ? '' : '/en';
        const url = new URL(`${location.protocol}${location.host}${lang}/pages/contact`);
        url.searchParams.append('prev', 'product_detail');
        url.searchParams.append('product_vendor', this.product.vendor);
        url.searchParams.append('product_title', this.product.title);
        url.searchParams.append('product_fku', this.product.getFkuByColorName(this.getSelectedColorName()));
        window.open(url.href, '_blank');
    }

    getSelectedColorName() {
        const isOneColor = document.getElementById('color-title-onecolor') != null;
        if (isOneColor) {
            // カラーバリエーションなしの場合
            return 'ONE_COLOR';
        }
        return document.getElementById('color-title').getAttribute('data-selected-color');
    }
}

customElements.define('contact-button', ContactButton);